<div class="text-center">
  <img width="120" src="/assets/img/logo.svg" alt="logo - allstar casino">
  <div class="my-80 sm:my-20">
    <img width="300" src="/assets/img/lock.png" alt="lock - allstar casino">
  </div>
  <div class="text-48 font-weight-800 uppercase sm:text-24">{{ 't.full-acc-lock-title' | translate }}</div>
  <div class="my-20">{{ 't.full-acc-lock-desc' | translate }}</div>
  <div class="flex justify-center my-20">
    <button (click)="zendesk.toggle()" class="btn btn--filled-primary small">{{ 'link.contact-us' | translate }}</button>
  </div>
  <div (click)="onLogout()" class="cursor-pointer uppercase logout font-weight-800">
    {{ 'link.logout' | translate }}
  </div>
</div>
